"use strict"

module.exports = require("./src/index.js")


//////////////////
// WEBPACK FOOTER
// ./node_modules/addsearch-js-client/index.js
// module id = 765
// module chunks = 0